import {
  ChangeDetectionStrategy, Component, Input, OnChanges
} from '@angular/core';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'bubble',
  template: `<div class="bubble__wrapper {{type}}">
  <div class="bubble__media">
    <icon [name]="iconName" size="16"></icon>
  </div>
  <div class="bubble__content">
    <ng-content></ng-content>
  </div>
</div>
`,
  styles: [`.bubble__wrapper{display:flex;align-items:center;border-radius:3px;background:#e8e8e8;padding:10px 10px 10px 15px;border:1px solid #e8e8e8}.bubble__wrapper .bubble__media{padding:7px;box-sizing:border-box;height:30px;flex:0 0 auto;width:30px;border-radius:50%;background:#fff;color:#e8e8e8;margin-right:15px;text-align:center}.bubble__wrapper .bubble__content{font-size:14px;line-height:15px;color:#363636}.bubble__wrapper .bubble__content p{margin-bottom:5px}.bubble__wrapper.info{background:#0081e3;border:1px solid #0081e3}.bubble__wrapper.info .bubble__media{color:#0081e3}.bubble__wrapper.info .bubble__content{color:#fff}.bubble__wrapper.warning{background:#ff7a00;border:1px solid #ff7a00}.bubble__wrapper.warning .bubble__media{color:#ff7a00}.bubble__wrapper.warning .bubble__content{color:#fff}.bubble__wrapper.error{background:#fff;border:1px solid #d80000}.bubble__wrapper.error .bubble__media{background:#d80000;color:#fff}.bubble__wrapper.error .bubble__content{color:#d80000}bubble-body{overflow:hidden}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BubbleComponent implements OnChanges {

  @Input('type') type: 'info'|'warning'|'error'|'help';
  public iconName: string;

  ngOnChanges() {
    this.iconName = ( Tools.isDefined(this.type) ) ?
      ( this.type !== 'warning' )
        ? this.type
        : 'error'
      : 'info';
  }
}
